import { Button, List, Modal, Text } from "@shopify/polaris";
import { useCancelSubscriptionMutation } from "../../../store/store/slices/BillingRTS";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { showToast } from "../../../store/store/slices/AlertSlice";

const CancelSubscription = ({
  id,
  name,
  refetchSubscription,
}: {
  id: string;
  name: string;
  refetchSubscription: () => void;
}) => {
  const dispatch = useDispatch();
  const [confirm, setConfirm] = useState<boolean>(false);
  const [cancelSubscription, { isLoading, isSuccess, isError }] =
    useCancelSubscriptionMutation();
  useEffect(() => {
    if (isSuccess) {
      refetchSubscription();
    }
    if (isError) {
      dispatch(
        showToast({
          error: true,
          message: "Something went wrong",
          visible: true,
        })
      );
    }
  }, [isLoading, isSuccess, isError]);

  const onCancelSubscriptionHandler = async () => {
    await cancelSubscription({ id, name });
  };
  const onConfirmCancelSubscription = () => {
    setConfirm(true);
  };
  return (
    <div style={{ marginTop: ".5rem" }}>
      <Button
        fullWidth
        variant="secondary"
        tone="critical"
        disabled={id === "" || name === "FREE"}
        onClick={onConfirmCancelSubscription}
        loading={!!id && isLoading}
      >
        Cancel subscription
      </Button>
      <Modal
        onClose={() => {
          setConfirm(false);
        }}
        primaryAction={{
          content: "Yes, proceed!",
          onAction: () => {
            setConfirm(false);
            onCancelSubscriptionHandler();
          },
          destructive: true,
        }}
        secondaryActions={[
          {
            content: "Cancel",

            onAction: () => {
              setConfirm(false);
            },
          },
        ]}
        open={confirm}
        title="Do you want to cancel your plan?"
      >
        <Modal.Section>
          Cancelling this plan will switch you to the FREE plan with limited
          features.
          <br></br>
          <Text as="span" fontWeight="bold">
            Also,
          </Text>
          <List>
            <List.Item>
              All user accounts except{" "}
              <Text as="span" fontWeight="bold">
                Admin{" "}
              </Text>
              will be deactivated
            </List.Item>
            <List.Item>
              All tracking accounts except{" "}
              <Text as="span" fontWeight="bold">
                Default{" "}
              </Text>
              will be deactivated.
            </List.Item>
          </List>
          <Text as="p">You will have to activate manually.</Text>
        </Modal.Section>
      </Modal>
    </div>
  );
};

export default CancelSubscription;
